import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ReportsComponent } from './components/reports/reports.component';
import { PrintReportComponent } from './components/print-report/print-report.component';

import { AuthorizationGuard } from '../app/guards/authorization.guard';
import { UploadsComponent } from './components/uploads/uploads.component';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { BinnacleComponent } from './components/binnacle/binnacle.component';
import { UsersComponent } from './components/users/users.component';
import { UsersAssignsComponent } from './components/users-assigns/users-assigns.component';
import { LoginComponent } from './components/login/login.component';
import { CompanyComponent } from './components/company/company.component';
import { ApplicationComponent } from './components/application/application.component';
import { ConnectionsComponent } from './components/connections/connections.component';
import { ReportUsersComponent } from './components/report-users/report-users.component';
const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home/' },
  { path: 'home/:UserId', component: HomeComponent,
  canActivate: [AuthorizationGuard]},
  {
    path: 'uploads',
    component: UploadsComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'file-manager',
    component: FileManagerComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'binnacle',
    component: BinnacleComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'user-assigns',
    component: UsersAssignsComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'connections',
    component: ConnectionsComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'report-users',
    component: ReportUsersComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'reports-crud/:CompanyKey/:AppKey',
    component: ReportsComponent,
    canActivate: [AuthorizationGuard]
  },
  // {
  //   path: 'print-report/:reportId',
  //   component: PrintReportComponent,
  //   //canActivate: [AuthorizationGuard]
  // },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'companies',
    component: CompanyComponent,
    canActivate: [AuthorizationGuard]
  },
  {
    path: 'applications',
    component: ApplicationComponent,
    canActivate: [AuthorizationGuard]
  },
  { path: '**', pathMatch: 'full', redirectTo: 'home/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
